import React from 'react';

import Header from 'components/Header';

const App = ({children}) => (
	<div className="outer-content-wrapper">
		<Header />
		<div className="main-section" role="main">
			{children}
		</div>
	</div>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js